import popAnimation from "@/components/popAnimation";
import { copy, checkCopyUsable } from '@ykz/ykz-util/platform';
export default {
  name: "appExclusive",
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    good: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    password: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      weChatId: getUrlParams("weChatId") || window.weChatId || 1
    };
  },
  components: {
    popAnimation: popAnimation
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit("update:visible", false);
    },
    handleDownload: function handleDownload() {
      var that = this;
      checkCopyUsable(10) && copy(that.password);
      that.$parent.logHelpers({
        event_id: "520003",
        element_content: "clickGoToDownloadBtnOnPop",
        cb: function cb() {
          window.location.href = "/front/index/appDownload?weChatId=" + that.weChatId;
        }
      });
    }
  }
};